export const SERVICE_TAG_TYPES = {
  CONVERSATION_HISTORY: "Conversation_history",
  USER_DETAILS: "User_Details",
  AUTHORIZATION: "Authorization",
  BUGTRACKER: "Bug_Tracker",
  USER_APPLICATIONS: "Use_Applications",
  REFERENCES: "References",
  ABSORB_LMS: "Absorb_Lms",

  // Notifications
  NOTIFICATIONS: "Notifications",
  NOTIFICATION_UNREAD_COUNT: "Notification_Unread_Count",
  NOTIFICATION_DRAWER_FILTERS: "Notification_Drawer_Filters",
};
